import FamilyMember, { FamilyMemberData } from './FamilyMember'

export interface CareReceiverData extends FamilyMemberData {
  care_receiver_id: string
  careDegree: string
  description: string
  age: number
  gender: string
  address: {
    street: string
    house_number: string
    postal_code: string
    city: string
    additional_information: string
  }
  insurance?: {
    insurance_company_id: string
  }
  vhp?: {
    wants_to_use_vhp_budget: boolean
  }
}

class CareReceiver extends FamilyMember {
  careDegree: string

  description: string

  age: number

  gender: string

  address: {
    street: string
    streetNumber: string
    postalCode: string
    city: string
    additionalInformation: string
  }

  vhp: {
    wantsToUseVhpBudget: boolean
  }

  insurance: {
    insuranceCompanyId: string | null
  }

  constructor({
    address: {
      additional_information: additionalInformation,
      city,
      house_number: streetNumber,
      postal_code: postalCode,
      street,
    },
    age,
    careDegree,
    care_receiver_id: careReceiverId,
    description,
    gender,
    insurance,
    vhp,
    ...props
  }: CareReceiverData) {
    super(props)

    this.careReceiverId = careReceiverId
    this.careDegree = careDegree
    this.description = description
    this.age = age
    this.gender = gender
    this.address = {
      street,
      streetNumber,
      postalCode,
      city,
      additionalInformation,
    }

    this.insurance = {
      insuranceCompanyId: insurance?.insurance_company_id || null,
    }

    this.vhp = {
      wantsToUseVhpBudget: vhp?.wants_to_use_vhp_budget || false,
    }
  }
}

export default CareReceiver
